import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import '../OrganisationStructure/Styling/OrgTabs.css';

const OrgTabs = () => {
  const history = useHistory();
  const { pathname } = useLocation();

  const getActiveTab = () => {
    if (pathname.includes('entity')) return 'entity';
    if (pathname.includes('unit')) return 'unit';
    return 'company';
  };

  const activeTab = getActiveTab();

  return (
    <div className="org-tab-wrapper">
      <div className="org-tab-container">
        <button
          className={`org-tab-btn ${activeTab === 'company' ? 'active' : ''}`}
          onClick={() => history.push('/new-company-profile')}
        >
          Company Details
        </button>
        <button
          className={`org-tab-btn ${activeTab === 'entity' ? 'active' : ''}`}
          onClick={() => history.push('/new-entity')}
        >
          Entity
        </button>
        <button
          className={`org-tab-btn ${activeTab === 'unit' ? 'active' : ''}`}
          onClick={() => history.push('/new-unit')}
        >
          Operating Units
        </button>
      </div>
    </div>
  );
};

export default OrgTabs;
